export const typeLogin = {
  "google-oauth2": "Google",
  apple: "Apple",
  facebook: "Facebook",
};
